import { useRepositoryQuery } from '@mews-commander/data-access';
import { TableState as OptimusTableState } from '@optimus-web/core';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { useReportIntervalLocal } from '../../../../common';
import { ReservationsFilterValues } from '../../filters';
import { ReservationsTableColumns, useFilterParams, useOrderParams } from '../../common';
import { ReservationTableFilters, ReservationsTableState } from './types';

type TableState = OptimusTableState<ReservationsTableState, ReservationTableFilters>;

interface UseGuestInHouseQueryParams {
    enabled: boolean;
    filterValues: ReservationsFilterValues;
    tableState: TableState;
}

export const useGuestInHouseQuery = ({ enabled, filterValues, tableState }: UseGuestInHouseQueryParams) => {
    const { filters, pagination, sort } = tableState;
    const orderParams = useOrderParams(sort);
    const filterParams = useFilterParams(filters);

    const guestVerificationPhotoEnabled = useFeatureFlag(FeatureFlag.guestVerificationPhotoOciConfigurationEnabled);

    const {
        startDate,
        endDate,
        productIds,
        serviceId,
        serviceOrderStatus,
        customerId,
        filterProductsInInterval,
        visibleColumns,
    } = filterValues;

    const reportIntervalLocal = useReportIntervalLocal({ startDate, endDate });

    const isBalanceAndPreauthorizationsVisible =
        visibleColumns?.includes(ReservationsTableColumns.Balance) ||
        visibleColumns?.includes(ReservationsTableColumns.Preauthorizations) ||
        !visibleColumns?.length;

    const extent = {
        balanceAndPreauthorizations: isBalanceAndPreauthorizationsVisible,
        verificationPhotos: guestVerificationPhotoEnabled,
    };

    return useRepositoryQuery(
        'guestInHouse',
        'getReservations',
        {
            guestInHouseFilters: {
                ...filterParams,
                serviceId,
                serviceOrderStatus,
                productIds,
                filterProductsInInterval,
                customerId: customerId ?? undefined,
                reportIntervalLocal,
            },
            ...orderParams,
            count: pagination.pageSize,
            startIndex: pagination.pageIndex * pagination.pageSize,
            extent,
        },
        { enabled }
    );
};
